import type { GetQuoteCartListResponse } from '../../../../../../../api/quotes.api.types';
import type { RaterXPreset } from '../../../api/types/rater-x-preset';
import type { PrimeXQuoteState } from '../../../types';
import type { EditQuoteState } from '../../edit-quote/types';
import type { PrimeXSimpleQuoteState } from '../../simple-request-quote/types';
import type { UnderwriteQuoteState } from '../../underwriter/types';

export interface CustomizeQuoteState extends PrimeXQuoteState {
  cartCount: number;
  /** The account-keyed cart. A submission has none: it counts coverage options instead. */
  cart?: GetQuoteCartListResponse;
  isRenewal: boolean;
  quoteCommission?: number;
}

export type DefaultQuoteOptions = {
  carrierPrefix?: string;
  effectiveDate: string;
  endDate: string;
  quoteCommissionRate: number;
  components?: RaterXPreset['components'];
};

export function isCustomizeQuoteState(
  quoteState: CustomizeQuoteState | PrimeXSimpleQuoteState
): quoteState is CustomizeQuoteState {
  return (quoteState as CustomizeQuoteState).coverageState != undefined;
}

export function isUnderwriteQuoteState(
  quoteState:
    | CustomizeQuoteState
    | Partial<EditQuoteState>
    | Partial<UnderwriteQuoteState>
) {
  return (
    (quoteState as UnderwriteQuoteState).amendatoryCoverageManager !=
      undefined && (quoteState as UnderwriteQuoteState).carriers != undefined
  );
}
